var CaptureStrategy;
(function (CaptureStrategy) {
    CaptureStrategy["automatic"] = "automatic";
    CaptureStrategy["manual"] = "manual";
})(CaptureStrategy || (CaptureStrategy = {}));
var PaymentMethodTypes;
(function (PaymentMethodTypes) {
    PaymentMethodTypes["card"] = "card";
    PaymentMethodTypes["bankAccount"] = "bankAccount";
    PaymentMethodTypes["sezzle"] = "sezzle";
    PaymentMethodTypes["saved"] = "saved";
})(PaymentMethodTypes || (PaymentMethodTypes = {}));
var PaymentTypes;
(function (PaymentTypes) {
    PaymentTypes["card"] = "Card";
    PaymentTypes["bankAccount"] = "ACH";
    PaymentTypes["unknown"] = "Unknown";
})(PaymentTypes || (PaymentTypes = {}));
var PaymentStatuses;
(function (PaymentStatuses) {
    PaymentStatuses["pending"] = "pending";
    PaymentStatuses["automatic"] = "automatic";
    PaymentStatuses["authorized"] = "authorized";
    PaymentStatuses["succeeded"] = "succeeded";
    PaymentStatuses["failed"] = "failed";
    PaymentStatuses["canceled"] = "canceled";
    PaymentStatuses["disputed"] = "disputed";
    PaymentStatuses["fully_refunded"] = "fully_refunded";
    PaymentStatuses["partially_refunded"] = "partially_refunded";
})(PaymentStatuses || (PaymentStatuses = {}));
var PaymentDisputedStatuses;
(function (PaymentDisputedStatuses) {
    // if a dispute is 'won', we don't show a dispute status, just general status
    PaymentDisputedStatuses["lost"] = "lost";
    PaymentDisputedStatuses["open"] = "open";
})(PaymentDisputedStatuses || (PaymentDisputedStatuses = {}));
class PaymentMethod {
    constructor(paymentMethod) {
        this.card = paymentMethod.card ? new Card(paymentMethod.card) : undefined;
        this.bank_account = paymentMethod.bank_account
            ? new BankAccount(paymentMethod.bank_account)
            : undefined;
    }
    get payersName() {
        if (this.card) {
            return this.card.name;
        }
        else if (this.bank_account) {
            return this.bank_account.name;
        }
        return null;
    }
    get lastFourDigits() {
        if (this.card) {
            return `**** ${this.card.acct_last_four}`;
        }
        else if (this.bank_account) {
            return `**** ${this.bank_account.acct_last_four}`;
        }
        return null;
    }
}
class BankAccount {
    constructor(bankAccount) {
        this.id = bankAccount.id;
        this.acct_last_four = bankAccount.acct_last_four;
        this.name = bankAccount.name;
        this.brand = bankAccount.brand;
        this.token = bankAccount.token;
        this.created_at = bankAccount.created_at;
        this.updated_at = bankAccount.updated_at;
    }
}
class Card {
    constructor(card) {
        this.id = card.id || '';
        this.acct_last_four = card.acct_last_four;
        this.name = card.name;
        this.brand = card.brand;
        this.token = card.token;
        this.created_at = card.created_at;
        this.updated_at = card.updated_at;
    }
}
class Payment {
    constructor(payment) {
        this.id = payment.id;
        this.account_id = payment.account_id;
        this.amount = payment.amount;
        this.amount_disputed = payment.amount_disputed;
        this.amount_refundable = payment.amount_refundable;
        this.amount_refunded = payment.amount_refunded;
        this.balance = payment.balance;
        this.captured = payment.captured;
        this.capture_strategy = payment.capture_strategy;
        this.currency = payment.currency;
        this.description = payment.description;
        this.disputed = payment.disputed;
        this.disputes = payment.disputes;
        this.error_code = payment.error_code;
        this.error_description = payment.error_description;
        this.fee_amount = payment.fee_amount;
        this.is_test = payment.is_test;
        this.metadata = payment.metadata;
        this.payment_method = new PaymentMethod(payment.payment_method);
        this.payment_intent_id = payment.payment_intent_id;
        this.refunded = payment.refunded;
        this.status = payment.status;
        this.created_at = payment.created_at;
        this.updated_at = payment.updated_at;
    }
    get disputedStatus() {
        const lost = this.disputes.some((dispute) => dispute.status === PaymentDisputedStatuses.lost);
        // if a dispute is 'won', we don't show a dispute status, just general status
        if (!this.disputed) {
            return null;
        }
        else if (lost) {
            return PaymentDisputedStatuses.lost;
        }
        else {
            return PaymentDisputedStatuses.open;
        }
    }
    get payment_type() {
        if (this.payment_method) {
            return this.payment_method.card ? PaymentTypes.card : PaymentTypes.bankAccount;
        }
        else {
            return PaymentTypes.unknown;
        }
    }
    get payers_name() {
        return this.payment_method.payersName;
    }
    get last_four_digits() {
        return this.payment_method.lastFourDigits;
    }
}

export { PaymentMethodTypes as P, Payment as a };
